import * as Types from '../../../graphql/types';

import { CalendarMonthString, CalendarDateTimeString, CalendarDateString } from "scalars";
import { gql } from '@apollo/client';
import { VendorFragmentDoc, VendorWithDetailsFragmentDoc } from '../../../graphql/fragments/vendor.generated';
import { FileFragmentDoc } from '../../../graphql/fragments/file.generated';
import { CustomerFragmentDoc } from '../../../graphql/fragments/customer.generated';
import { ProductFragmentDoc, ProductWithDetailsFragmentDoc } from '../../../graphql/fragments/product.generated';
import { CategoryFragmentDoc } from '../../../graphql/fragments/category.generated';
import { MoneyFragmentDoc } from '../../../graphql/fragments/money.generated';
import { CompanyFragmentDoc } from '../../../graphql/fragments/company.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetVendorsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  page?: Types.InputMaybe<Types.PageInput>;
  filterBy?: Types.InputMaybe<Types.VendorFilterBy>;
  sortBy?: Types.InputMaybe<Types.VendorSortOrder>;
}>;


export type GetVendorsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, vendors: { __typename?: 'VendorPaginator', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, total?: number | null }, items: Array<{ __typename?: 'Vendor', id: string, permaName: string, name: string, description?: string | null, is1099Vendor: Types.YesNoUnknown, status?: Types.VendorStatus | null, type?: Types.VendorType | null }> } } | null };

export type GetVendorQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  page?: Types.InputMaybe<Types.PageInput>;
  filterBy?: Types.InputMaybe<Types.VendorFilterBy>;
  sortBy?: Types.InputMaybe<Types.VendorSortOrder>;
}>;


export type GetVendorQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, vendors: { __typename?: 'VendorPaginator', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, total?: number | null }, items: Array<{ __typename?: 'Vendor', id: string, name: string, addressJson?: any | null, companyName?: string | null, contactName?: string | null, currency?: any | null, description?: string | null, email?: string | null, is1099Vendor: Types.YesNoUnknown, phoneNumber?: string | null, status?: Types.VendorStatus | null, taxIdType?: Types.TaxIdType | null, type?: Types.VendorType | null, website?: string | null, documents: Array<{ __typename?: 'VendorDocument', file: { __typename?: 'File', id: string, filename?: string | null, contentType: string, size: number, isDeleted: boolean, downloadInfo: { __typename?: 'FileDownloadInfo', signedUrl: string, urlExpiresAt: CalendarDateTimeString } } }> }> } } | null };

export type VendorSecretsQueryVariables = Types.Exact<{
  input: Types.GetVendorSecretsInput;
}>;


export type VendorSecretsQuery = { __typename?: 'Query', vendorSecrets: { __typename?: 'GetVendorSecretsResult', secrets?: { __typename?: 'VendorSecrets', taxId?: string | null } | null } };

export type CustomerQueryVariables = Types.Exact<{
  input: Types.CustomerQueryInput;
}>;


export type CustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, billingAddressJson?: any | null } | null };

export type GetCustomerFormQueryVariables = Types.Exact<{
  input: Types.CustomerQueryInput;
}>;


export type GetCustomerFormQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', name?: string | null, companyName?: string | null, website?: string | null, description?: string | null, status?: Types.CustomerStatus | null, type?: Types.CustomerType | null, contactName?: string | null, email?: string | null, phoneNumber?: string | null, billingAddressJson?: any | null, documents?: Array<{ __typename?: 'CustomerDocument', file: { __typename?: 'File', id: string, filename?: string | null, contentType: string, size: number, isDeleted: boolean, downloadInfo: { __typename?: 'FileDownloadInfo', signedUrl: string, urlExpiresAt: CalendarDateTimeString } } } | null> | null } | null };

export type CustomersQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  filterBy?: Types.InputMaybe<Types.CustomerFilterBy>;
  page?: Types.InputMaybe<Types.PageInput>;
  sortBy?: Types.InputMaybe<Types.CustomerSortOrder>;
}>;


export type CustomersQuery = { __typename?: 'Query', customers: { __typename?: 'CustomerPaginator', items: Array<{ __typename?: 'Customer', id: string, name?: string | null, email?: string | null, type?: Types.CustomerType | null, status?: Types.CustomerStatus | null, description?: string | null, invoiceStats: { __typename?: 'InvoiceStatsResult', total: number } }> } };

export type PagedCustomersQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  filterBy?: Types.InputMaybe<Types.CustomerFilterBy>;
  page?: Types.InputMaybe<Types.PageInput>;
  sortBy?: Types.InputMaybe<Types.CustomerSortOrder>;
  invoiceFilterBy?: Types.InputMaybe<Types.InvoiceFilterBy>;
}>;


export type PagedCustomersQuery = { __typename?: 'Query', customers: { __typename?: 'CustomerPaginator', items: Array<{ __typename?: 'Customer', id: string, name?: string | null, email?: string | null, type?: Types.CustomerType | null, status?: Types.CustomerStatus | null, description?: string | null, receivableBalance: { __typename?: 'ReceivableBalance', unpaidCount: number, appliedBalance: { __typename?: 'Money', amount: string, currency: any }, remainingBalance: { __typename?: 'Money', amount: string, currency: any } }, filteredInvoiceStats: { __typename?: 'InvoiceStatsResult', total: number }, invoiceStats: { __typename?: 'InvoiceStatsResult', total: number } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total?: number | null } } };

export type ProductsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  filterBy?: Types.InputMaybe<Types.ProductFilterBy>;
  page?: Types.InputMaybe<Types.PageInput>;
  sortBy?: Types.InputMaybe<Types.ProductSortOrder>;
}>;


export type ProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductPaginator', items: Array<{ __typename?: 'Product', id: string, name?: string | null }> } };

export type PagedProductsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  filterBy?: Types.InputMaybe<Types.ProductFilterBy>;
  page?: Types.InputMaybe<Types.PageInput>;
  sortBy?: Types.InputMaybe<Types.ProductSortOrder>;
}>;


export type PagedProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductPaginator', items: Array<{ __typename?: 'Product', id: string, name?: string | null, serviceType?: Types.ProductServiceType | null, status?: Types.ProductStatus | null, sku?: string | null, description?: string | null, priceRate?: string | null, invoiceStats: { __typename?: 'InvoiceStatsResult', total: number } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total?: number | null } } };

export type GetProductFormQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  productId: Types.Scalars['ID']['input'];
}>;


export type GetProductFormQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name?: string | null, serviceType?: Types.ProductServiceType | null, status?: Types.ProductStatus | null, sku?: string | null, description?: string | null, priceRate?: string | null, invoiceStats: { __typename?: 'InvoiceStatsResult', total: number } } | null };

export type CategoriesQueryVariables = Types.Exact<{
  input: Types.CategoryQueryInput;
}>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename: 'LedgerCategory', defaultCashlike: Types.Cashlike, accountType?: Types.LedgerAccountType | null, views?: Array<string | null> | null, name: string, permaKey: string, examples?: string | null, description?: string | null, coaDisplayId?: string | null, coaKey: string, deprecated?: boolean | null, ruleType?: string | null, displayName: string, displayId: string, shortName: string, companyId: string, id?: string | null }> };

export type CreateVendorMutationVariables = Types.Exact<{
  input: Types.CreateVendorInput;
}>;


export type CreateVendorMutation = { __typename?: 'Mutation', createVendor: { __typename?: 'CreateVendorResult', vendor: { __typename?: 'Vendor', id: string, permaName: string, name: string, description?: string | null, is1099Vendor: Types.YesNoUnknown, status?: Types.VendorStatus | null, type?: Types.VendorType | null } } };

export type CreateCustomerMutationVariables = Types.Exact<{
  input: Types.CreateCustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer: { __typename?: 'CreateCustomerResult', customer: { __typename?: 'Customer', id: string, name?: string | null, email?: string | null, type?: Types.CustomerType | null, status?: Types.CustomerStatus | null, description?: string | null, invoiceStats: { __typename?: 'InvoiceStatsResult', total: number } } } };

export type UpdateCustomerMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'UpdateCustomerResult', customer: { __typename?: 'Customer', id: string, name?: string | null, email?: string | null, type?: Types.CustomerType | null, status?: Types.CustomerStatus | null, description?: string | null, invoiceStats: { __typename?: 'InvoiceStatsResult', total: number } } } };

export type CreateProductMutationVariables = Types.Exact<{
  input: Types.CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'CreateProductResult', product: { __typename?: 'Product', id: string, name?: string | null } } };

export type UpdateProductMutationVariables = Types.Exact<{
  input: Types.UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'UpdateProductResult', product: { __typename?: 'Product', id: string, name?: string | null, serviceType?: Types.ProductServiceType | null, status?: Types.ProductStatus | null, sku?: string | null, description?: string | null, priceRate?: string | null, invoiceStats: { __typename?: 'InvoiceStatsResult', total: number } } } };

export type PagedCustomerFragment = { __typename?: 'Customer', id: string, name?: string | null, email?: string | null, type?: Types.CustomerType | null, status?: Types.CustomerStatus | null, description?: string | null, receivableBalance: { __typename?: 'ReceivableBalance', unpaidCount: number, appliedBalance: { __typename?: 'Money', amount: string, currency: any }, remainingBalance: { __typename?: 'Money', amount: string, currency: any } }, filteredInvoiceStats: { __typename?: 'InvoiceStatsResult', total: number }, invoiceStats: { __typename?: 'InvoiceStatsResult', total: number } };

export type AccountingRecordActivity_AccountingRecordComment_Fragment = { __typename?: 'AccountingRecordComment', text: string, id: string, createdAt: CalendarDateTimeString, type: Types.AccountingRecordActivityType, createdByUser?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type AccountingRecordActivity_AccountingRecordFileDeleted_Fragment = { __typename?: 'AccountingRecordFileDeleted', id: string, createdAt: CalendarDateTimeString, type: Types.AccountingRecordActivityType, file: { __typename?: 'File', id: string, filename?: string | null, contentType: string, size: number, isDeleted: boolean, downloadInfo: { __typename?: 'FileDownloadInfo', signedUrl: string, urlExpiresAt: CalendarDateTimeString } }, createdByUser?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type AccountingRecordActivity_AccountingRecordFileUploaded_Fragment = { __typename?: 'AccountingRecordFileUploaded', id: string, createdAt: CalendarDateTimeString, type: Types.AccountingRecordActivityType, file: { __typename?: 'File', id: string, filename?: string | null, contentType: string, size: number, isDeleted: boolean, downloadInfo: { __typename?: 'FileDownloadInfo', signedUrl: string, urlExpiresAt: CalendarDateTimeString } }, createdByUser?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type AccountingRecordActivityFragment = AccountingRecordActivity_AccountingRecordComment_Fragment | AccountingRecordActivity_AccountingRecordFileDeleted_Fragment | AccountingRecordActivity_AccountingRecordFileUploaded_Fragment;

export type AddAccountingRecordCommentMutationVariables = Types.Exact<{
  input: Types.AddAccountingRecordCommentInput;
}>;


export type AddAccountingRecordCommentMutation = { __typename?: 'Mutation', addAccountingRecordComment: { __typename?: 'AccountingRecordComment', text: string, id: string, createdAt: CalendarDateTimeString, type: Types.AccountingRecordActivityType, createdByUser?: { __typename?: 'User', id?: string | null, name?: string | null } | null } };

export type DataAnomalyReviewQueryVariables = Types.Exact<{
  input: Types.DataAnomalyReviewInput;
}>;


export type DataAnomalyReviewQuery = { __typename?: 'Query', dataAnomalyReview: { __typename?: 'DataAnomalyReviewResult', review: { __typename?: 'AccountEndingBalanceReview', context: { __typename?: 'AccountEndingBalanceReviewContext', reconciledThrough?: CalendarDateString | null, ledgerMinusBestGuessBalance: { __typename?: 'Money', amount: string, currency: any } } } } };

export type UpdateVendorMutationVariables = Types.Exact<{
  input: Types.UpdateVendorInput;
}>;


export type UpdateVendorMutation = { __typename?: 'Mutation', updateVendor: { __typename?: 'UpdateVendorResult', vendor: { __typename?: 'Vendor', permaName: string, name: string, id: string } } };

export type MergeVendorsMutationVariables = Types.Exact<{
  input: Types.MergeVendorInput;
}>;


export type MergeVendorsMutation = { __typename?: 'Mutation', mergeVendors: { __typename?: 'MergeVendorResult', success: boolean } };

export type AvailableClassSegmentFragment = { __typename?: 'AvailableClassSegment', id: any, name: any, description?: string | null, createdAt: CalendarDateTimeString, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type AvailableReportingClassFragment = { __typename?: 'AvailableReportingClass', id: any, name: any, description?: string | null, type: Types.ReportingClassType, createdAt: CalendarDateTimeString, availableValues: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, description?: string | null, createdAt: CalendarDateTimeString, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null }>, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type GetCompanyAvailableClassesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GetCompanyAvailableClassesQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, availableClasses: { __typename?: 'AvailableClassesResult', departments: { __typename?: 'AvailableReportingClass', id: any, name: any, description?: string | null, type: Types.ReportingClassType, createdAt: CalendarDateTimeString, availableValues: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, description?: string | null, createdAt: CalendarDateTimeString, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null }>, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null }, locations: { __typename?: 'AvailableReportingClass', id: any, name: any, description?: string | null, type: Types.ReportingClassType, createdAt: CalendarDateTimeString, availableValues: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, description?: string | null, createdAt: CalendarDateTimeString, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null }>, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null }, userCreated: Array<{ __typename?: 'AvailableReportingClass', id: any, name: any, description?: string | null, type: Types.ReportingClassType, createdAt: CalendarDateTimeString, availableValues: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, description?: string | null, createdAt: CalendarDateTimeString, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null }>, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null }> } } | null };

export type ClassAwareEntity_BillLine_Fragment = { __typename?: 'BillLine', classAwareType: Types.ClassAwareType, billLineId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> };

export type ClassAwareEntity_InvoiceDiscountLine_Fragment = { __typename?: 'InvoiceDiscountLine', classAwareType: Types.ClassAwareType, invoiceDiscountLineId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> };

export type ClassAwareEntity_InvoiceLine_Fragment = { __typename?: 'InvoiceLine', classAwareType: Types.ClassAwareType, invoiceItemId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> };

export type ClassAwareEntity_InvoiceShippingLine_Fragment = { __typename?: 'InvoiceShippingLine', classAwareType: Types.ClassAwareType, invoiceShippingLineId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> };

export type ClassAwareEntity_InvoiceTaxLine_Fragment = { __typename?: 'InvoiceTaxLine', classAwareType: Types.ClassAwareType, invoiceTaxLineId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> };

export type ClassAwareEntity_ManualJournalEntryItem_Fragment = { __typename?: 'ManualJournalEntryItem', id: string, classAwareType: Types.ClassAwareType, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> };

export type ClassAwareEntity_TransactionDetail_Fragment = { __typename?: 'TransactionDetail', id: string, classAwareType: Types.ClassAwareType, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> };

export type ClassAwareEntityFragment = ClassAwareEntity_BillLine_Fragment | ClassAwareEntity_InvoiceDiscountLine_Fragment | ClassAwareEntity_InvoiceLine_Fragment | ClassAwareEntity_InvoiceShippingLine_Fragment | ClassAwareEntity_InvoiceTaxLine_Fragment | ClassAwareEntity_ManualJournalEntryItem_Fragment | ClassAwareEntity_TransactionDetail_Fragment;

export type ApplyClassToEntityMutationVariables = Types.Exact<{
  input: Types.ApplyClassToEntityInput;
}>;


export type ApplyClassToEntityMutation = { __typename?: 'Mutation', applyClassToEntity: { __typename?: 'BillLine', classAwareType: Types.ClassAwareType, billLineId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } | { __typename?: 'InvoiceDiscountLine', classAwareType: Types.ClassAwareType, invoiceDiscountLineId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } | { __typename?: 'InvoiceLine', classAwareType: Types.ClassAwareType, invoiceItemId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } | { __typename?: 'InvoiceShippingLine', classAwareType: Types.ClassAwareType, invoiceShippingLineId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } | { __typename?: 'InvoiceTaxLine', classAwareType: Types.ClassAwareType, invoiceTaxLineId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } | { __typename?: 'ManualJournalEntryItem', id: string, classAwareType: Types.ClassAwareType, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } | { __typename?: 'TransactionDetail', id: string, classAwareType: Types.ClassAwareType, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } };

export type RemoveClassFromEntityMutationVariables = Types.Exact<{
  input: Types.RemoveClassFromEntityInput;
}>;


export type RemoveClassFromEntityMutation = { __typename?: 'Mutation', removeClassFromEntity: { __typename?: 'BillLine', classAwareType: Types.ClassAwareType, billLineId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } | { __typename?: 'InvoiceDiscountLine', classAwareType: Types.ClassAwareType, invoiceDiscountLineId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } | { __typename?: 'InvoiceLine', classAwareType: Types.ClassAwareType, invoiceItemId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } | { __typename?: 'InvoiceShippingLine', classAwareType: Types.ClassAwareType, invoiceShippingLineId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } | { __typename?: 'InvoiceTaxLine', classAwareType: Types.ClassAwareType, invoiceTaxLineId: any, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } | { __typename?: 'ManualJournalEntryItem', id: string, classAwareType: Types.ClassAwareType, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } | { __typename?: 'TransactionDetail', id: string, classAwareType: Types.ClassAwareType, classSegments: Array<{ __typename?: 'AvailableClassSegment', id: any, name: any, reportingClass: { __typename?: 'AvailableReportingClass', id: any, name: any, type: Types.ReportingClassType } }> } };

export type CreateReportingClassMutationVariables = Types.Exact<{
  input: Types.CreateReportingClassInput;
}>;


export type CreateReportingClassMutation = { __typename?: 'Mutation', createReportingClass: { __typename?: 'Company', id: string, name: string, type: Types.CompanyType, createdAt: CalendarDateTimeString, onboardingStage: Types.OnboardingStage, uniquePathname: string, timeZone?: string | null, trackingId?: string | null, revenueModel?: Types.RevenueModel | null } };

export type CreateClassSegmentMutationVariables = Types.Exact<{
  input: Types.CreateClassSegmentInput;
}>;


export type CreateClassSegmentMutation = { __typename?: 'Mutation', createClassSegment: { __typename?: 'Company', id: string, name: string, type: Types.CompanyType, createdAt: CalendarDateTimeString, onboardingStage: Types.OnboardingStage, uniquePathname: string, timeZone?: string | null, trackingId?: string | null, revenueModel?: Types.RevenueModel | null } };

export const PagedCustomerFragmentDoc = gql`
    fragment pagedCustomer on Customer {
  ...customer
  receivableBalance {
    appliedBalance {
      ...money
    }
    remainingBalance {
      ...money
    }
    unpaidCount
  }
  filteredInvoiceStats: invoiceStats(filterBy: $invoiceFilterBy) {
    total
  }
}
    ${CustomerFragmentDoc}
${MoneyFragmentDoc}`;
export const AccountingRecordActivityFragmentDoc = gql`
    fragment accountingRecordActivity on AccountingRecordActivity {
  id
  createdAt
  type
  createdByUser {
    id
    name
  }
  ... on AccountingRecordComment {
    text
  }
  ... on AccountingRecordFileUploaded {
    file {
      ...file
    }
  }
  ... on AccountingRecordFileDeleted {
    file {
      ...file
    }
  }
}
    ${FileFragmentDoc}`;
export const AvailableClassSegmentFragmentDoc = gql`
    fragment availableClassSegment on AvailableClassSegment {
  id
  name
  description
  createdAt
  createdBy {
    id
    name
  }
}
    `;
export const AvailableReportingClassFragmentDoc = gql`
    fragment availableReportingClass on AvailableReportingClass {
  id
  name
  description
  availableValues {
    ...availableClassSegment
  }
  type
  createdAt
  createdBy {
    id
    name
  }
}
    ${AvailableClassSegmentFragmentDoc}`;
export const ClassAwareEntityFragmentDoc = gql`
    fragment classAwareEntity on WithReportingClasses {
  ... on TransactionDetail {
    id
  }
  ... on InvoiceLine {
    invoiceItemId: id
  }
  ... on InvoiceDiscountLine {
    invoiceDiscountLineId: id
  }
  ... on InvoiceShippingLine {
    invoiceShippingLineId: id
  }
  ... on InvoiceTaxLine {
    invoiceTaxLineId: id
  }
  ... on ManualJournalEntryItem {
    id
  }
  ... on BillLine {
    billLineId: id
  }
  classAwareType
  classSegments {
    id
    name
    reportingClass {
      id
      name
      type
    }
  }
}
    `;
export const GetVendorsDocument = gql`
    query getVendors($companyId: ID!, $page: PageInput, $filterBy: VendorFilterBy, $sortBy: VendorSortOrder) {
  company(id: $companyId) {
    id
    vendors(page: $page, filterBy: $filterBy, sortBy: $sortBy) {
      pageInfo {
        endCursor
        hasNextPage
        total
      }
      items {
        ...vendor
      }
    }
  }
}
    ${VendorFragmentDoc}`;

/**
 * __useGetVendorsQuery__
 *
 * To run a query within a React component, call `useGetVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      page: // value for 'page'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetVendorsQuery(baseOptions: Apollo.QueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables> & ({ variables: GetVendorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
      }
export function useGetVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
        }
export function useGetVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
        }
export type GetVendorsQueryHookResult = ReturnType<typeof useGetVendorsQuery>;
export type GetVendorsLazyQueryHookResult = ReturnType<typeof useGetVendorsLazyQuery>;
export type GetVendorsSuspenseQueryHookResult = ReturnType<typeof useGetVendorsSuspenseQuery>;
export type GetVendorsQueryResult = Apollo.QueryResult<GetVendorsQuery, GetVendorsQueryVariables>;
export const GetVendorDocument = gql`
    query getVendor($companyId: ID!, $page: PageInput, $filterBy: VendorFilterBy, $sortBy: VendorSortOrder) {
  company(id: $companyId) {
    id
    vendors(page: $page, filterBy: $filterBy, sortBy: $sortBy) {
      pageInfo {
        endCursor
        hasNextPage
        total
      }
      items {
        ...vendorWithDetails
      }
    }
  }
}
    ${VendorWithDetailsFragmentDoc}`;

/**
 * __useGetVendorQuery__
 *
 * To run a query within a React component, call `useGetVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      page: // value for 'page'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetVendorQuery(baseOptions: Apollo.QueryHookOptions<GetVendorQuery, GetVendorQueryVariables> & ({ variables: GetVendorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument, options);
      }
export function useGetVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorQuery, GetVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument, options);
        }
export function useGetVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVendorQuery, GetVendorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument, options);
        }
export type GetVendorQueryHookResult = ReturnType<typeof useGetVendorQuery>;
export type GetVendorLazyQueryHookResult = ReturnType<typeof useGetVendorLazyQuery>;
export type GetVendorSuspenseQueryHookResult = ReturnType<typeof useGetVendorSuspenseQuery>;
export type GetVendorQueryResult = Apollo.QueryResult<GetVendorQuery, GetVendorQueryVariables>;
export const VendorSecretsDocument = gql`
    query VendorSecrets($input: GetVendorSecretsInput!) {
  vendorSecrets(input: $input) {
    secrets {
      taxId
    }
  }
}
    `;

/**
 * __useVendorSecretsQuery__
 *
 * To run a query within a React component, call `useVendorSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorSecretsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVendorSecretsQuery(baseOptions: Apollo.QueryHookOptions<VendorSecretsQuery, VendorSecretsQueryVariables> & ({ variables: VendorSecretsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorSecretsQuery, VendorSecretsQueryVariables>(VendorSecretsDocument, options);
      }
export function useVendorSecretsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorSecretsQuery, VendorSecretsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorSecretsQuery, VendorSecretsQueryVariables>(VendorSecretsDocument, options);
        }
export function useVendorSecretsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorSecretsQuery, VendorSecretsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VendorSecretsQuery, VendorSecretsQueryVariables>(VendorSecretsDocument, options);
        }
export type VendorSecretsQueryHookResult = ReturnType<typeof useVendorSecretsQuery>;
export type VendorSecretsLazyQueryHookResult = ReturnType<typeof useVendorSecretsLazyQuery>;
export type VendorSecretsSuspenseQueryHookResult = ReturnType<typeof useVendorSecretsSuspenseQuery>;
export type VendorSecretsQueryResult = Apollo.QueryResult<VendorSecretsQuery, VendorSecretsQueryVariables>;
export const CustomerDocument = gql`
    query customer($input: CustomerQueryInput!) {
  customer(input: $input) {
    id
    name
    email
    phoneNumber
    billingAddressJson
  }
}
    `;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerQuery(baseOptions: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables> & ({ variables: CustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export function useCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerSuspenseQueryHookResult = ReturnType<typeof useCustomerSuspenseQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const GetCustomerFormDocument = gql`
    query getCustomerForm($input: CustomerQueryInput!) {
  customer(input: $input) {
    name
    companyName
    website
    description
    status
    type
    contactName
    email
    phoneNumber
    billingAddressJson
    documents {
      file {
        ...file
      }
    }
  }
}
    ${FileFragmentDoc}`;

/**
 * __useGetCustomerFormQuery__
 *
 * To run a query within a React component, call `useGetCustomerFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerFormQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomerFormQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerFormQuery, GetCustomerFormQueryVariables> & ({ variables: GetCustomerFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerFormQuery, GetCustomerFormQueryVariables>(GetCustomerFormDocument, options);
      }
export function useGetCustomerFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerFormQuery, GetCustomerFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerFormQuery, GetCustomerFormQueryVariables>(GetCustomerFormDocument, options);
        }
export function useGetCustomerFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerFormQuery, GetCustomerFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerFormQuery, GetCustomerFormQueryVariables>(GetCustomerFormDocument, options);
        }
export type GetCustomerFormQueryHookResult = ReturnType<typeof useGetCustomerFormQuery>;
export type GetCustomerFormLazyQueryHookResult = ReturnType<typeof useGetCustomerFormLazyQuery>;
export type GetCustomerFormSuspenseQueryHookResult = ReturnType<typeof useGetCustomerFormSuspenseQuery>;
export type GetCustomerFormQueryResult = Apollo.QueryResult<GetCustomerFormQuery, GetCustomerFormQueryVariables>;
export const CustomersDocument = gql`
    query customers($companyId: ID!, $filterBy: CustomerFilterBy, $page: PageInput, $sortBy: CustomerSortOrder) {
  customers(
    companyId: $companyId
    filterBy: $filterBy
    page: $page
    sortBy: $sortBy
  ) {
    items {
      ...customer
    }
  }
}
    ${CustomerFragmentDoc}`;

/**
 * __useCustomersQuery__
 *
 * To run a query within a React component, call `useCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filterBy: // value for 'filterBy'
 *      page: // value for 'page'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useCustomersQuery(baseOptions: Apollo.QueryHookOptions<CustomersQuery, CustomersQueryVariables> & ({ variables: CustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
      }
export function useCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
        }
export function useCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
        }
export type CustomersQueryHookResult = ReturnType<typeof useCustomersQuery>;
export type CustomersLazyQueryHookResult = ReturnType<typeof useCustomersLazyQuery>;
export type CustomersSuspenseQueryHookResult = ReturnType<typeof useCustomersSuspenseQuery>;
export type CustomersQueryResult = Apollo.QueryResult<CustomersQuery, CustomersQueryVariables>;
export const PagedCustomersDocument = gql`
    query pagedCustomers($companyId: ID!, $filterBy: CustomerFilterBy, $page: PageInput, $sortBy: CustomerSortOrder, $invoiceFilterBy: InvoiceFilterBy) {
  customers(
    companyId: $companyId
    filterBy: $filterBy
    page: $page
    sortBy: $sortBy
  ) {
    items {
      ...pagedCustomer
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${PagedCustomerFragmentDoc}`;

/**
 * __usePagedCustomersQuery__
 *
 * To run a query within a React component, call `usePagedCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedCustomersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filterBy: // value for 'filterBy'
 *      page: // value for 'page'
 *      sortBy: // value for 'sortBy'
 *      invoiceFilterBy: // value for 'invoiceFilterBy'
 *   },
 * });
 */
export function usePagedCustomersQuery(baseOptions: Apollo.QueryHookOptions<PagedCustomersQuery, PagedCustomersQueryVariables> & ({ variables: PagedCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedCustomersQuery, PagedCustomersQueryVariables>(PagedCustomersDocument, options);
      }
export function usePagedCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedCustomersQuery, PagedCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedCustomersQuery, PagedCustomersQueryVariables>(PagedCustomersDocument, options);
        }
export function usePagedCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedCustomersQuery, PagedCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedCustomersQuery, PagedCustomersQueryVariables>(PagedCustomersDocument, options);
        }
export type PagedCustomersQueryHookResult = ReturnType<typeof usePagedCustomersQuery>;
export type PagedCustomersLazyQueryHookResult = ReturnType<typeof usePagedCustomersLazyQuery>;
export type PagedCustomersSuspenseQueryHookResult = ReturnType<typeof usePagedCustomersSuspenseQuery>;
export type PagedCustomersQueryResult = Apollo.QueryResult<PagedCustomersQuery, PagedCustomersQueryVariables>;
export const ProductsDocument = gql`
    query products($companyId: ID!, $filterBy: ProductFilterBy, $page: PageInput, $sortBy: ProductSortOrder) {
  products(
    companyId: $companyId
    filterBy: $filterBy
    page: $page
    sortBy: $sortBy
  ) {
    items {
      ...product
    }
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filterBy: // value for 'filterBy'
 *      page: // value for 'page'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useProductsQuery(baseOptions: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables> & ({ variables: ProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export function useProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsSuspenseQueryHookResult = ReturnType<typeof useProductsSuspenseQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const PagedProductsDocument = gql`
    query pagedProducts($companyId: ID!, $filterBy: ProductFilterBy, $page: PageInput, $sortBy: ProductSortOrder) {
  products(
    companyId: $companyId
    filterBy: $filterBy
    page: $page
    sortBy: $sortBy
  ) {
    items {
      ...productWithDetails
    }
    pageInfo {
      hasNextPage
      endCursor
      total
    }
  }
}
    ${ProductWithDetailsFragmentDoc}`;

/**
 * __usePagedProductsQuery__
 *
 * To run a query within a React component, call `usePagedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagedProductsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filterBy: // value for 'filterBy'
 *      page: // value for 'page'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function usePagedProductsQuery(baseOptions: Apollo.QueryHookOptions<PagedProductsQuery, PagedProductsQueryVariables> & ({ variables: PagedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagedProductsQuery, PagedProductsQueryVariables>(PagedProductsDocument, options);
      }
export function usePagedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagedProductsQuery, PagedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagedProductsQuery, PagedProductsQueryVariables>(PagedProductsDocument, options);
        }
export function usePagedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagedProductsQuery, PagedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagedProductsQuery, PagedProductsQueryVariables>(PagedProductsDocument, options);
        }
export type PagedProductsQueryHookResult = ReturnType<typeof usePagedProductsQuery>;
export type PagedProductsLazyQueryHookResult = ReturnType<typeof usePagedProductsLazyQuery>;
export type PagedProductsSuspenseQueryHookResult = ReturnType<typeof usePagedProductsSuspenseQuery>;
export type PagedProductsQueryResult = Apollo.QueryResult<PagedProductsQuery, PagedProductsQueryVariables>;
export const GetProductFormDocument = gql`
    query getProductForm($companyId: ID!, $productId: ID!) {
  product(companyId: $companyId, productId: $productId) {
    ...productWithDetails
  }
}
    ${ProductWithDetailsFragmentDoc}`;

/**
 * __useGetProductFormQuery__
 *
 * To run a query within a React component, call `useGetProductFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductFormQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProductFormQuery(baseOptions: Apollo.QueryHookOptions<GetProductFormQuery, GetProductFormQueryVariables> & ({ variables: GetProductFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductFormQuery, GetProductFormQueryVariables>(GetProductFormDocument, options);
      }
export function useGetProductFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductFormQuery, GetProductFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductFormQuery, GetProductFormQueryVariables>(GetProductFormDocument, options);
        }
export function useGetProductFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductFormQuery, GetProductFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductFormQuery, GetProductFormQueryVariables>(GetProductFormDocument, options);
        }
export type GetProductFormQueryHookResult = ReturnType<typeof useGetProductFormQuery>;
export type GetProductFormLazyQueryHookResult = ReturnType<typeof useGetProductFormLazyQuery>;
export type GetProductFormSuspenseQueryHookResult = ReturnType<typeof useGetProductFormSuspenseQuery>;
export type GetProductFormQueryResult = Apollo.QueryResult<GetProductFormQuery, GetProductFormQueryVariables>;
export const CategoriesDocument = gql`
    query categories($input: CategoryQueryInput!) {
  categories(input: $input) {
    ...category
  }
}
    ${CategoryFragmentDoc}`;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables> & ({ variables: CategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export function useCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesSuspenseQueryHookResult = ReturnType<typeof useCategoriesSuspenseQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const CreateVendorDocument = gql`
    mutation createVendor($input: CreateVendorInput!) {
  createVendor(input: $input) {
    vendor {
      ...vendor
    }
  }
}
    ${VendorFragmentDoc}`;
export type CreateVendorMutationFn = Apollo.MutationFunction<CreateVendorMutation, CreateVendorMutationVariables>;

/**
 * __useCreateVendorMutation__
 *
 * To run a mutation, you first call `useCreateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorMutation, { data, loading, error }] = useCreateVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVendorMutation(baseOptions?: Apollo.MutationHookOptions<CreateVendorMutation, CreateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVendorMutation, CreateVendorMutationVariables>(CreateVendorDocument, options);
      }
export type CreateVendorMutationHookResult = ReturnType<typeof useCreateVendorMutation>;
export type CreateVendorMutationResult = Apollo.MutationResult<CreateVendorMutation>;
export type CreateVendorMutationOptions = Apollo.BaseMutationOptions<CreateVendorMutation, CreateVendorMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation createCustomer($input: CreateCustomerInput!) {
  createCustomer(input: $input) {
    customer {
      ...customer
    }
  }
}
    ${CustomerFragmentDoc}`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation updateCustomer($input: UpdateCustomerInput!) {
  updateCustomer(input: $input) {
    customer {
      ...customer
    }
  }
}
    ${CustomerFragmentDoc}`;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const CreateProductDocument = gql`
    mutation createProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    product {
      ...product
    }
  }
}
    ${ProductFragmentDoc}`;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    product {
      ...productWithDetails
    }
  }
}
    ${ProductWithDetailsFragmentDoc}`;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const AddAccountingRecordCommentDocument = gql`
    mutation addAccountingRecordComment($input: AddAccountingRecordCommentInput!) {
  addAccountingRecordComment(input: $input) {
    ...accountingRecordActivity
  }
}
    ${AccountingRecordActivityFragmentDoc}`;
export type AddAccountingRecordCommentMutationFn = Apollo.MutationFunction<AddAccountingRecordCommentMutation, AddAccountingRecordCommentMutationVariables>;

/**
 * __useAddAccountingRecordCommentMutation__
 *
 * To run a mutation, you first call `useAddAccountingRecordCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountingRecordCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccountingRecordCommentMutation, { data, loading, error }] = useAddAccountingRecordCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAccountingRecordCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddAccountingRecordCommentMutation, AddAccountingRecordCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccountingRecordCommentMutation, AddAccountingRecordCommentMutationVariables>(AddAccountingRecordCommentDocument, options);
      }
export type AddAccountingRecordCommentMutationHookResult = ReturnType<typeof useAddAccountingRecordCommentMutation>;
export type AddAccountingRecordCommentMutationResult = Apollo.MutationResult<AddAccountingRecordCommentMutation>;
export type AddAccountingRecordCommentMutationOptions = Apollo.BaseMutationOptions<AddAccountingRecordCommentMutation, AddAccountingRecordCommentMutationVariables>;
export const DataAnomalyReviewDocument = gql`
    query dataAnomalyReview($input: DataAnomalyReviewInput!) {
  dataAnomalyReview(input: $input) {
    review {
      ... on AccountEndingBalanceReview {
        context {
          reconciledThrough
          ledgerMinusBestGuessBalance {
            amount
            currency
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDataAnomalyReviewQuery__
 *
 * To run a query within a React component, call `useDataAnomalyReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataAnomalyReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataAnomalyReviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDataAnomalyReviewQuery(baseOptions: Apollo.QueryHookOptions<DataAnomalyReviewQuery, DataAnomalyReviewQueryVariables> & ({ variables: DataAnomalyReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataAnomalyReviewQuery, DataAnomalyReviewQueryVariables>(DataAnomalyReviewDocument, options);
      }
export function useDataAnomalyReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataAnomalyReviewQuery, DataAnomalyReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataAnomalyReviewQuery, DataAnomalyReviewQueryVariables>(DataAnomalyReviewDocument, options);
        }
export function useDataAnomalyReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataAnomalyReviewQuery, DataAnomalyReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataAnomalyReviewQuery, DataAnomalyReviewQueryVariables>(DataAnomalyReviewDocument, options);
        }
export type DataAnomalyReviewQueryHookResult = ReturnType<typeof useDataAnomalyReviewQuery>;
export type DataAnomalyReviewLazyQueryHookResult = ReturnType<typeof useDataAnomalyReviewLazyQuery>;
export type DataAnomalyReviewSuspenseQueryHookResult = ReturnType<typeof useDataAnomalyReviewSuspenseQuery>;
export type DataAnomalyReviewQueryResult = Apollo.QueryResult<DataAnomalyReviewQuery, DataAnomalyReviewQueryVariables>;
export const UpdateVendorDocument = gql`
    mutation updateVendor($input: UpdateVendorInput!) {
  updateVendor(input: $input) {
    vendor {
      permaName
      name
      id
    }
  }
}
    `;
export type UpdateVendorMutationFn = Apollo.MutationFunction<UpdateVendorMutation, UpdateVendorMutationVariables>;

/**
 * __useUpdateVendorMutation__
 *
 * To run a mutation, you first call `useUpdateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorMutation, { data, loading, error }] = useUpdateVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVendorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorMutation, UpdateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVendorMutation, UpdateVendorMutationVariables>(UpdateVendorDocument, options);
      }
export type UpdateVendorMutationHookResult = ReturnType<typeof useUpdateVendorMutation>;
export type UpdateVendorMutationResult = Apollo.MutationResult<UpdateVendorMutation>;
export type UpdateVendorMutationOptions = Apollo.BaseMutationOptions<UpdateVendorMutation, UpdateVendorMutationVariables>;
export const MergeVendorsDocument = gql`
    mutation mergeVendors($input: MergeVendorInput!) {
  mergeVendors(input: $input) {
    success
  }
}
    `;
export type MergeVendorsMutationFn = Apollo.MutationFunction<MergeVendorsMutation, MergeVendorsMutationVariables>;

/**
 * __useMergeVendorsMutation__
 *
 * To run a mutation, you first call `useMergeVendorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeVendorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeVendorsMutation, { data, loading, error }] = useMergeVendorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeVendorsMutation(baseOptions?: Apollo.MutationHookOptions<MergeVendorsMutation, MergeVendorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeVendorsMutation, MergeVendorsMutationVariables>(MergeVendorsDocument, options);
      }
export type MergeVendorsMutationHookResult = ReturnType<typeof useMergeVendorsMutation>;
export type MergeVendorsMutationResult = Apollo.MutationResult<MergeVendorsMutation>;
export type MergeVendorsMutationOptions = Apollo.BaseMutationOptions<MergeVendorsMutation, MergeVendorsMutationVariables>;
export const GetCompanyAvailableClassesDocument = gql`
    query getCompanyAvailableClasses($companyId: ID!) {
  company(id: $companyId) {
    id
    availableClasses {
      departments {
        ...availableReportingClass
      }
      locations {
        ...availableReportingClass
      }
      userCreated {
        ...availableReportingClass
      }
    }
  }
}
    ${AvailableReportingClassFragmentDoc}`;

/**
 * __useGetCompanyAvailableClassesQuery__
 *
 * To run a query within a React component, call `useGetCompanyAvailableClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyAvailableClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyAvailableClassesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyAvailableClassesQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyAvailableClassesQuery, GetCompanyAvailableClassesQueryVariables> & ({ variables: GetCompanyAvailableClassesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyAvailableClassesQuery, GetCompanyAvailableClassesQueryVariables>(GetCompanyAvailableClassesDocument, options);
      }
export function useGetCompanyAvailableClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyAvailableClassesQuery, GetCompanyAvailableClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyAvailableClassesQuery, GetCompanyAvailableClassesQueryVariables>(GetCompanyAvailableClassesDocument, options);
        }
export function useGetCompanyAvailableClassesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyAvailableClassesQuery, GetCompanyAvailableClassesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyAvailableClassesQuery, GetCompanyAvailableClassesQueryVariables>(GetCompanyAvailableClassesDocument, options);
        }
export type GetCompanyAvailableClassesQueryHookResult = ReturnType<typeof useGetCompanyAvailableClassesQuery>;
export type GetCompanyAvailableClassesLazyQueryHookResult = ReturnType<typeof useGetCompanyAvailableClassesLazyQuery>;
export type GetCompanyAvailableClassesSuspenseQueryHookResult = ReturnType<typeof useGetCompanyAvailableClassesSuspenseQuery>;
export type GetCompanyAvailableClassesQueryResult = Apollo.QueryResult<GetCompanyAvailableClassesQuery, GetCompanyAvailableClassesQueryVariables>;
export const ApplyClassToEntityDocument = gql`
    mutation applyClassToEntity($input: ApplyClassToEntityInput!) {
  applyClassToEntity(input: $input) {
    ...classAwareEntity
  }
}
    ${ClassAwareEntityFragmentDoc}`;
export type ApplyClassToEntityMutationFn = Apollo.MutationFunction<ApplyClassToEntityMutation, ApplyClassToEntityMutationVariables>;

/**
 * __useApplyClassToEntityMutation__
 *
 * To run a mutation, you first call `useApplyClassToEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyClassToEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyClassToEntityMutation, { data, loading, error }] = useApplyClassToEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyClassToEntityMutation(baseOptions?: Apollo.MutationHookOptions<ApplyClassToEntityMutation, ApplyClassToEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyClassToEntityMutation, ApplyClassToEntityMutationVariables>(ApplyClassToEntityDocument, options);
      }
export type ApplyClassToEntityMutationHookResult = ReturnType<typeof useApplyClassToEntityMutation>;
export type ApplyClassToEntityMutationResult = Apollo.MutationResult<ApplyClassToEntityMutation>;
export type ApplyClassToEntityMutationOptions = Apollo.BaseMutationOptions<ApplyClassToEntityMutation, ApplyClassToEntityMutationVariables>;
export const RemoveClassFromEntityDocument = gql`
    mutation removeClassFromEntity($input: RemoveClassFromEntityInput!) {
  removeClassFromEntity(input: $input) {
    ...classAwareEntity
  }
}
    ${ClassAwareEntityFragmentDoc}`;
export type RemoveClassFromEntityMutationFn = Apollo.MutationFunction<RemoveClassFromEntityMutation, RemoveClassFromEntityMutationVariables>;

/**
 * __useRemoveClassFromEntityMutation__
 *
 * To run a mutation, you first call `useRemoveClassFromEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClassFromEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClassFromEntityMutation, { data, loading, error }] = useRemoveClassFromEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveClassFromEntityMutation(baseOptions?: Apollo.MutationHookOptions<RemoveClassFromEntityMutation, RemoveClassFromEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveClassFromEntityMutation, RemoveClassFromEntityMutationVariables>(RemoveClassFromEntityDocument, options);
      }
export type RemoveClassFromEntityMutationHookResult = ReturnType<typeof useRemoveClassFromEntityMutation>;
export type RemoveClassFromEntityMutationResult = Apollo.MutationResult<RemoveClassFromEntityMutation>;
export type RemoveClassFromEntityMutationOptions = Apollo.BaseMutationOptions<RemoveClassFromEntityMutation, RemoveClassFromEntityMutationVariables>;
export const CreateReportingClassDocument = gql`
    mutation createReportingClass($input: CreateReportingClassInput!) {
  createReportingClass(input: $input) {
    ...company
  }
}
    ${CompanyFragmentDoc}`;
export type CreateReportingClassMutationFn = Apollo.MutationFunction<CreateReportingClassMutation, CreateReportingClassMutationVariables>;

/**
 * __useCreateReportingClassMutation__
 *
 * To run a mutation, you first call `useCreateReportingClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportingClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportingClassMutation, { data, loading, error }] = useCreateReportingClassMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportingClassMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportingClassMutation, CreateReportingClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportingClassMutation, CreateReportingClassMutationVariables>(CreateReportingClassDocument, options);
      }
export type CreateReportingClassMutationHookResult = ReturnType<typeof useCreateReportingClassMutation>;
export type CreateReportingClassMutationResult = Apollo.MutationResult<CreateReportingClassMutation>;
export type CreateReportingClassMutationOptions = Apollo.BaseMutationOptions<CreateReportingClassMutation, CreateReportingClassMutationVariables>;
export const CreateClassSegmentDocument = gql`
    mutation createClassSegment($input: CreateClassSegmentInput!) {
  createClassSegment(input: $input) {
    ...company
  }
}
    ${CompanyFragmentDoc}`;
export type CreateClassSegmentMutationFn = Apollo.MutationFunction<CreateClassSegmentMutation, CreateClassSegmentMutationVariables>;

/**
 * __useCreateClassSegmentMutation__
 *
 * To run a mutation, you first call `useCreateClassSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClassSegmentMutation, { data, loading, error }] = useCreateClassSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClassSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateClassSegmentMutation, CreateClassSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClassSegmentMutation, CreateClassSegmentMutationVariables>(CreateClassSegmentDocument, options);
      }
export type CreateClassSegmentMutationHookResult = ReturnType<typeof useCreateClassSegmentMutation>;
export type CreateClassSegmentMutationResult = Apollo.MutationResult<CreateClassSegmentMutation>;
export type CreateClassSegmentMutationOptions = Apollo.BaseMutationOptions<CreateClassSegmentMutation, CreateClassSegmentMutationVariables>;